/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { isLight } from 'utils/theme'
import sitefilter_styles from 'material/sitefilter/sitefilter_styles';

const typefaceOptions = {
  DECORATIVE_AND_PLAIN: {
    SYSTEM: {
      header: 'serif',
      body: 'sans-serif'
    },
    HIGH_FIDELITY: {
      header: '"Source Serif Pro",Georgia, serif',
      body: '"Work Sans", Verdana, sans-serif'
    }
  },
  DECORATIVE: {
    SYSTEM: {
      header: 'serif',
      body: 'serif'
    },
    HIGH_FIDELITY: {
      header: '"Source Serif Pro",Georgia, serif',
      body: '"Source Serif Pro",Georgia, serif',
    }
  },
  PLAIN: {
    SYSTEM: {
      header: 'sans-serif',
      body: 'sans-serif'
    },
    HIGH_FIDELITY: {
      header: '"Work Sans", Verdana, sans-serif',
      body: '"Work Sans", Verdana, sans-serif'
    }
  },
}

const titleSizeOption = {
  SMALL: '12px',
  MEDIUM: '14px',
  LARGE: '16px'
}

const featuredTitleSize = {
  SMALL: '15px',
  MEDIUM: '17px',
  LARGE: '19px'
}

const headerSizeOptions = {
  SMALL: '16px',
  MEDIUM: '18px',
  LARGE: '20px'
}

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - THEME PREVIEW : STYLES --------------- ++++++++++ */
export default theme => ({
  themepreview: {
    '& .previewconfig': {
      '& .content': {
        flexDirection: 'column',
        background: props => props.siteTheme.backgroundColor || '#FFF',
        color: props => isLight(props.siteTheme.backgroundColor) ? '#000000' : '#FFFFFF',
        '& > div': {
          maxWidth: pxToEm(450),
        },
        '& .articlecard': {
          width: 'calc(100% - 8px)',
          minWidth: ' calc(100% - 8px)',
        },
        '& .container': {
          maxWidth: pxToEm(450),
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)'
        },
        '& .loadmore': {
          display: 'flex',
          width: pxToEm(180),
          height: pxToEm(36),
          padding: `${pxToEm(16)} 0`,
          justifyContent: 'center',
          alignItems: 'center',
          background: '#000',
          color: '#FFF',
          borderRadius: pxToEm(30),
          fontSize: pxToEm(14)
        },
        '& h3': {
          fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].header || 'serif',
          paddingBottom: pxToEm(8),
          borderBottom: ({ themeColors }) => `3px solid ${themeColors['neutrals.bodyText']}`
        },
        '& .arrowwrap': {
          position: 'relative',
          width: 0,
          top: pxToEm(-24),
          '& svg': {
            position: 'relative'
          }
        },
        '& .leftarrow': {
          left: pxToEm(-12)
        },
        '& .rightarrow': {
          left: pxToEm(-20)
        }
      }
    },
   '& svg': {
      fill: ({ themeColors }) => themeColors['primary']
    },
    '& .articlecardinfo, & .articlecard': {
      background: ({ themeColors }) => themeColors['backgroundPrimary'],
      borderColor: ({ themeColors }) => themeColors['backgroundPrimary']
    },
    '& h1, & h3': {
      color: ({ themeColors }) => themeColors['neutrals.bodyText']
    },
    '& h3': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].header || 'serif',
      fontSize: ({ siteTheme }) => headerSizeOptions[siteTheme.fontSize] || '18px',
      fontWeight: 600
    },
    '& p, & .titlewrap': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].body || 'sans-serif',
      fontSize: ({ siteTheme }) => titleSizeOption[siteTheme.fontSize] || '14px',
      fontWeight: 400
    },
    '& span': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].body || 'sans-serif'
    },
    '& h1': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].header || 'serif',
      fontSize: '24px',
      fontWeight: 600
    },
    '& .viewscounter': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].body || 'serif',
      fontSize: ({ siteTheme }) => titleSizeOption[siteTheme.fontSize] || '14px',
      color: ({ themeColors }) => themeColors['secondaryText'],
      marginBottom: ({ siteTheme }) => siteTheme.fontSize === 'SMALL' ? '8px' : '4px',
      '& svg > path': {
        fill: ({ themeColors }) => themeColors['secondaryText']
      }
    },
    '& .titlewrap': {
      top: ({ siteTheme }) => siteTheme.fontSize === 'SMALL' ? '14px' : '12px'
    },
    '& .featured .titlewrap': {
      fontSize:  ({ siteTheme }) => featuredTitleSize[siteTheme.fontSize] || '15px',
      marginBottom: pxToEm(4)
    }
  }
});
